<template>
  <div class="cases">
    <div v-if="loading">
      <loading-messages v-if="loading"></loading-messages>
    </div>
    <div class="list-group" v-if="!loading && cases && cases.length > 0">
      <router-link
        v-for="item of cases"
        :to="`/p/case/${item.id}`"
        :key="item.id"
        class="nounderline"
      >
        <CaseLink :value="item"></CaseLink>
      </router-link>
    </div>
    <div class="alert alert-primary" v-else-if="!loading">
      <p>{{ $t("nocases") }}</p>
      <p>{{ $t("youcancontactdoctor") }}</p>
      <p>
        {{ $t("gotodoctorspage") }}
        <router-link
          :to="`/doctors`"
          class="chat-with-us py-2 pl-1 pointer svg"
        >
          <DoctorIcon></DoctorIcon>
          <span class="pl-2">{{ $t("doctors") }}</span>
        </router-link>
      </p>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import LoadingMessages from '@/components/Loadings/Message'
import DoctorIcon from '@/components/Icons/Doctor'
import CaseLink from '@/components/Cases/Link'
export default {
  components: {
    LoadingMessages,
    DoctorIcon,
    CaseLink
  },
  metaInfo: {
    title: 'My Cases'
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      cases: 'pcase/cases'
    })
  },
  mounted () {
    this.setNavVisible(false)
    this.setHead({ url: '/', text: this.$t('cases') })
    this.fetch()
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setHead: 'head/set',
      resetHead: 'head/reset',
      setNavVisible: 'app/setNavVisible',
      setError: 'alert/setError',
      authUser: 'auth/user',
      setCase: 'pcase/set'
    }),
    async fetch () {
      this.loading = true
      try {
        const params = {
          offset: 0,
          limit: 50,
          patient_id: this.authUser.id
        }
        const response = await this.axios.get('/api/patient-cases', { params })
        for (const c of response.data.data) {
          this.setCase(c)
        }
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
    "cases": "ჩანაწერები",
    "nocases": "თქვენ არ გაქვთ არც ერთი კონსულტაცია",
    "youcancontactdoctor": "შეგიძლიათ ჩაეწეროთ ონლაინ კონსულტაციაზე, მიხვიდეთ კლინიკაში ან გამოიძახოთ ექიმი სასურველ მისამართზე",
    "gotodoctorspage": "სერვისის მისაღებად შეარჩიეთ",
    "doctors": "ექიმი"
  }
}
</i18n>
